<template>
    <el-container class="is-vertical" style="flex-shrink: 0">
        <el-main class="login-register">
            <div class="headings">
                <h2>Palette editor</h2>
            </div>
            <div class="palettes">
                <sketch-picker class="palette-sketch-picker" v-on-clickaway="away" 
                    v-bind:style="{ top: `${cursorY}px`, left: `${cursorX}px` }"
                    v-model="sketchColor"
                    disableAlpha
                    v-if="sketchOpen"
                    @input="(color) => setColor(color)"
                    :presetColors="COLOR_PALETTE" 
                />
                <el-row v-masonry transition-duration="0s" item-selector=".masonry-item" class="masonry-container"
                        el-row
                        type="flex" :gutter="6" justify="center"
                        :width="{'100%': !$store.state.libLoading, '99%': $store.state.libLoading}">
                    <el-col v-for="(palette,paletteInd) in palettes" :key="paletteInd" :xs="24" :sm="24" :md="12" :lg="8"
                            :xl="6">
                        <div class="palette" :class="{changed: palette.changed}">
                            <div class="flex-center">
                                <el-input placeholder="Please input" v-model="palette.name"
                                          @input="palette.changed=true"></el-input>
                                <a class="el-button el-button--success el-button--medium"
                                   style="margin-left: 15px;"
                                   v-if="palette.changed"
                                   @click.prevent="savePalette(paletteInd)">SAVE</a>
                            </div>
                            <div class="colors">
                                <div class="colors-row d-flex" v-for="(color, colorInd) in palette.colors"
                                     :key="colorInd">
                                    <div class="d-flex align-center justify-between flex-grow">
                                        <div class="picker-wrap-palette d-flex align-center">Background:
                                            <div class="palette-color-btn" v-on:click="(event)=>openSketch(paletteInd,colorInd,'b',event)" v-bind:style="{ background: color.b }"></div>
                                        </div>

                                        <div class="butto-swap" @click="flipColors(paletteInd, colorInd)"></div>

                                        <!-- <el-button icon="custom-icon" class="has-shadow"
                                                   @click="flipColors(paletteInd, colorInd)"></el-button> -->

                                        <div class="picker-wrap-palette d-flex align-center">Text:
                                            <div class="palette-color-btn" v-on:click="(event)=>openSketch(paletteInd,colorInd,'t',event)" v-bind:style="{ background: color.t }"></div>
                                        </div>
                                    </div>
                                    <el-button type="danger" icon="el-icon-delete" circle
                                               v-if="palette.colors.length > 1" class="has-shadow"
                                               @click="deleteRow(paletteInd, colorInd)"></el-button>
                                </div>
                            </div>
                            <div class="colors-row d-flex justify-center">
                                <el-button type="success" icon="el-icon-plus" circle
                                           class="has-shadow" @click="addRow(paletteInd)"></el-button>
                            </div>
                            <div class="flex-center">
                                <el-button type="warning" style="margin-top: 20px"
                                           class="has-shadow" @click="copyPalette(paletteInd)">COPY PALETTE</el-button>
                            </div>
                            <div class="flex-center">
                                <el-button type="danger" style="margin-top: 20px"
                                           class="has-shadow" @click="deletePalette(paletteInd)">DELETE PALETTE</el-button>
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="6">
                        <div class="colors-row flex-center h-100">
                            <el-button type="success" icon="el-icon-plus" circle style="font-size: 65px; padding: 18px; opacity: 0.9"
                                       class="shadowfloat" @click="createNewPalette"></el-button>
                        </div>
                    </el-col>
                </el-row>

            </div>
        </el-main>
    </el-container>
</template>

<script>
    import {Sketch} from 'vue-color'
    import { directive as onClickaway } from 'vue-clickaway';
    const COLOR_PALETTE = Object.freeze([
        '#efcdff', '#dc99ff', '#c367ff', '#aa3fff', '#8400ff', '#6400db', '#4b01b9', '#340095', '#24007b',
        '#e4fcda', '#c7f8b4', '#9fec8c', '#77d86c', '#43bf3f', '#2da435', '#1d8a2e', '#136e28', '#0b5b25',
        '#d1f6fe', '#a4e6fe', '#77d2fc', '#55bdfb', '#1e9bf7', '#1578d3', '#0e5ab1', '#083f8f', '#052c76',
        '#fdf5cc', '#fee998', '#fedb67', '#fdcc3f', '#ffb200', '#d99301', '#b67501', '#915901', '#794700',
        '#fdd4d9', '#fdabb9', '#fd80a2', '#fd609c', '#fe2c91', '#d9208d', '#b51684', '#910e77', '#78086c',
        '#fde5d8', '#fec5b1', '#fd9f8a', '#fe7a6d', '#fd3e3b', '#d92c37', '#b51e36', '#911232', '#790b2f',
        '#fdeccd', '#fdd599', '#fdb666', '#fe9940', '#fd6801', '#da4c01', '#b53400', '#912100', '#791401',
        '#ffffff', '#E6E6E6', '#CDCDCD', '#B4B4B4', '#9B9B9B', '#828282', '#696969', '#373737', '#000000',
    ])
    export default {
        name: 'paletteEditor',
        data() {
            return {
                palettes: [],
                sketchColor: null,
                sketchOpen: false,
                cursorX: 0,
                cursorY: 0,
                sketchCurentItem: {
                    pInd: null,
                    cInd: null,
                    k: null
                },
                COLOR_PALETTE
            }
        },
        mounted() {
            if (this.$store.state.user.role.name !== "Administrator") {
                this.$router.push("/my-library")
            }
            this.axios.get(this.$store.state.API_URL + 'colorpalettes').then((response) => {
                this.palettes = response.data;
            })
        },
        directives: {
            onClickaway: onClickaway,
        },
        methods: {
            savePalette(ind) {
                let p = this.palettes[ind];
                this.axios[p._id ? "put" : "post"](this.$store.state.API_URL + 'colorpalettes/' + (p._id || ""), p).then((response) => {
                    this.palettes.splice(ind, 1, response.data);
                    // this.$forceUpdate()
                })
            },
            away(){
                this.sketchOpen = false;
            },
            copyPalette(ind){
                this.palettes.push(JSON.parse(JSON.stringify(this.palettes[ind])))
            },
            deletePalette(ind) {
                let p = this.palettes[ind];
                if(p._id) {
                    this.$confirm('This will permanently delete the palette. Continue?', 'Warning', {
                        confirmButtonClass: "el-button--danger danger-important",
                        confirmButtonText: 'DELETE',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                    }).then(() => {
                        this.axios.delete(this.$store.state.API_URL + 'colorpalettes/' + p._id).then((response) => {
                            this.palettes.splice(ind, 1);
                            this.$message({
                                type: 'success',
                                message: 'Palette deleted'
                            });
                        })
                    })
                } else {
                    this.palettes.splice(ind, 1);
                    this.$message({
                        type: 'success',
                        message: 'Palette deleted'
                    });
                }

            },
            rgbToHex(rgb) {
                function intToHex(c) {
                    var hex = parseInt(c.trim()).toString(16);
                    return hex.length === 1 ? "0" + hex : hex;
                }
                return "#" + rgb.slice(4, -1).split(",").map(intToHex).join("");
            },
            openSketch(pInd,cInd,k,e){
                if(this.sketchOpen) this.sketchOpen = false;
                this.sketchCurentItem={pInd,cInd,k} 
                this.sketchColor = this.palettes[pInd].colors[cInd][k]
                this.cursorX = Math.abs(e.pageX - 225);
                this.cursorY = e.pageY;

                this.sketchOpen=true;
                e.stopPropagation();
            },
            setColor(val) {
                let { pInd, cInd, k} = this.sketchCurentItem
                this.palettes[pInd].colors[cInd][k] = val.hex
            },
            flipColors(pInd, cInd) {
                this.palettes[pInd].changed = true;
                [this.palettes[pInd].colors[cInd].b, this.palettes[pInd].colors[cInd].t] = [this.palettes[pInd].colors[cInd].t, this.palettes[pInd].colors[cInd].b]
            },
            deleteRow(pInd, cInd) {
                this.palettes[pInd].colors.splice(cInd, 1);
                this.palettes[pInd].changed = true;
            },
            addRow(pInd) {
                this.palettes[pInd].colors.push(JSON.parse(JSON.stringify(this.palettes[pInd].colors.slice(-1)[0])))
                this.palettes[pInd].changed = true;
            },
            createNewPalette() {
                let newPalette = {
                    name: "New Palette",
                    changed: true,
                    colors: [{
                        b: "#ffffff",
                        t: "#000000",
                    }]
                }
                this.palettes.push(newPalette)
            }
        },
        components: {
            'sketch-picker': Sketch
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/Palette.vue